export default {
  START: 'AUTH/SESSION/START',
  CLOSE: 'AUTH/SESSION/CLOSE'
}
